import { useCallback } from 'react';
import { calculateSFP, evaluateAllModels } from '../utils/calculations';
import { useAppContext } from '../contexts/AppContext';
import { exportToCSV, exportToPDF } from '../utils/export';
export function useEvaluation() {
    const { profile, activeWeightProfile } = useAppContext();
    const evaluate = useCallback(() => {
        return evaluateAllModels(profile, activeWeightProfile);
    }, [profile, activeWeightProfile]);
    const evaluateSingle = useCallback((model) => {
        return calculateSFP(model, profile, activeWeightProfile);
    }, [profile, activeWeightProfile]);
    return { evaluate, evaluateSingle };
}
export function useExport() {
    const { profile, activeWeightProfile } = useAppContext();
    const handleExportJSON = useCallback((scores) => {
        const data = {
            profile: { profile, weights: activeWeightProfile },
            results: scores,
            generated: new Date().toISOString(),
        };
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `decidepro-${new Date().toISOString().slice(0, 10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
    }, [profile, activeWeightProfile]);
    const handleExportCSV = useCallback((scores) => {
        const blob = exportToCSV(scores);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `decidepro-${new Date().toISOString().slice(10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }, []);
    const handleExportPDF = useCallback((scores) => {
        exportToPDF(scores, { profile, weights: activeWeightProfile });
    }, [profile, activeWeightProfile]);
    return {
        exportJSON: handleExportJSON,
        exportCSV: handleExportCSV,
        exportPDF: handleExportPDF,
    };
}
export { RadarChart } from '../components/charts/RadarChart';
export { GaugeChart } from '../components/charts/GaugeChart';
